module.exports = __webpack_public_path__ + "chest.f3db9e50.png";


//////////////////
// WEBPACK FOOTER
// /var/www/build-lk-1/src/components/profile/imgs/chest.png
// module id = 1922
// module chunks = 0